import { Component, OnInit } from '@angular/core';
import { AutocompleteNode } from '../common/ceq-unit-autocomplete/ceq-unit-autocomplete.component';
import { GlobalFunctionsService } from 'src/app/ceq/common/functions/global-functions.service';
import { SettingsService } from '../../core/settings/settings.service';
import { CeveService } from "../catalog/ceve/ceve.service";
import { OrgService } from '../catalog/org/org.service';
import { UserLogin } from 'src/app/ceq/common/models/UserLogin.Model';
import { Org } from 'src/app/ceq/common/models/Org.Model';
import { PaybillService } from 'src/app/ceq/self-service/balance/paybill/paybill.service';
import * as moment from 'moment';
import { DatePipe } from '@angular/common';
import {Ceve} from '../common/models/Ceve.Model';
import { Unit } from '../common/models/Unit.Model';
import { Route } from 'src/app/ceq/common/models/Route.Model';
import { forkJoin } from 'rxjs';


interface Channel {
  ChannelCode: string;
  UnitId: number;
  ChannelName: string;
}

@Component({
  selector: 'app-paybill-multichannel',
  templateUrl: './paybill-multichannel.component.html',
  styleUrls: ['./paybill-multichannel.component.scss']
})
export class PaybillMultichannelComponent implements OnInit {

  constructor(
    private settingsService: SettingsService,
    private globalService: GlobalFunctionsService,
      private ceveService: CeveService,
    private orgServ: OrgService,
    private paybillService: PaybillService,
  ) { }

  userLogin: UserLogin;
  userCeves: number[];

  ceveNode: AutocompleteNode;
  initialNode: AutocompleteNode;
  channelList: Channel[] = []; 
  loadData: any[] = [];
  baseLoadData: any[] = [];
  cols: string[] = [];
  selectedChannel: string;
  selectedChannelId: number = 0;
  selectedRoutelId: number = 0;
  selectedChannelIds: number[] = [];
  org: Org[] = [];
  orgId: number = 0;
  working: boolean = false;
  saving: boolean = false;
  currentDate: Date;
  selectedDate: string;
  selectedDateFinal: string;
  selectedOrg: Org;
  selectedCeve: Ceve;
  filtered: boolean = false;
  loading: boolean = false;
  collectionDate: string = moment(new Date()).format('YYYY-MM-DD');
  collectionDateEnd: string = moment(new Date()).format('YYYY-MM-DD');
  datepipe: DatePipe = new DatePipe('en-US');
  ceqListGrid:any[] = [];
  routes: Route[] = [];

  selectedUnit: Unit = undefined;
  maxDate: string;
  minDate: string;

  selectedRoute: number=0;
  noRoute: boolean = false;

  // Arreglo para almacenar los IDs de las rutas seleccionadas.
  selectedRoutes: number[] = [];
  // Bandera para controlar la opción "TODAS".
  selectAll: boolean = false;
  // Bandera para deshabilitar el control, si es necesario.
 // noRoute: boolean = false;
  // Estado del dropdown (abierto o cerrado).
  dropdownOpen: boolean = false;

    // Bandera para deshabilitar el control, si es necesario.
 // noRoute: boolean = false;
  // Estado del dropdown (abierto o cerrado).
  dropdownOpenChannel: boolean = false;
 // Array para almacenar los códigos de los canales seleccionados
 selectedChannels: string[] = [];
 // Variable para controlar la opción "TODOS"
 selectAllChannels: boolean = false;


  ngOnInit(): void {
    this.currentDate = new Date();
    this.selectedDate = this.globalService.getStringDate(this.currentDate, false, 0);
    this.selectedDateFinal = this.globalService.getStringDate(this.currentDate, false, 0);
    this.userLogin = this.settingsService.getUser();
    this.getOrg();
  }


   // Alterna la visibilidad del dropdown.
   toggleDropdown(): void {
    this.dropdownOpen = !this.dropdownOpen;
  }

     // Alterna la visibilidad del dropdown.
     toggleDropdownChannel(): void {
      this.dropdownOpenChannel = !this.dropdownOpenChannel;
    }

  // Maneja la selección de "TODAS": selecciona o deselecciona todas las rutas.
  toggleSelectAll(): void {
    if (this.selectAll) {
      this.selectedRoutes = this.routes.map(route => route.RouteId);
    } else {
      this.selectedRoutes = [0];
    }
  }

closeDropdown() {
  this.dropdownOpenChannel = false;
  this.dropdownOpen = false;
}

  // Maneja el cambio individual de cada checkbox.
  onRouteChange(event: any, routeId: number): void {
    if (event.target.checked) {
      if (!this.selectedRoutes.includes(routeId)) {
        this.selectedRoutes.push(routeId);
      }
    } else {
      this.selectedRoutes = this.selectedRoutes.filter(id => id !== routeId);
      // Si se desmarca una opción, se desmarca "TODAS"
      this.selectAll = false;
    }
    this.getPaybillListExpiredList();
    
  }

  toggleRoutes(event: any, routeId: number): void {
    if (this.selectedRoutes.includes(0)) {
      this.selectAll = false;
      this.selectedRoutes = this.selectedRoutes.filter(id => id !== 0);
    }
  
    if (this.selectedRoutes.includes(0)) {
      this.selectedRoutes = this.selectedRoutes.filter(id => id !== routeId);
    } else {
      this.selectedRoutes.push(routeId);
    }
  
    // Si todos los canales están seleccionados, activamos "TODOS"
    if (this.selectedChannels.length === this.channelList.length) {
      this.selectAllChannels = true;
      this.selectedChannels = ["0"];
    }
    if (this.selectedRoutes.length === this.routes.length) {
      this.selectAll = true;
      this.selectedRoutes = [0];
    }
  }


    // Selecciona o deselecciona todos los canales
    toggleSelectAllChannels(): void {
      if (this.selectAllChannels) {
        // Agrega todos los códigos de canal al arreglo de seleccionados
        this.selectedChannels = this.channelList.map(ch => ch.ChannelCode);
      } else {
        // Limpia la selección
        this.selectedChannels = [];
      }
    }
  
    // Maneja la selección individual de cada canal
    onChannelChange(event: any, channelCode: string): void {
      if (event.target.checked) {
        if (!this.selectedChannels.includes(channelCode)) {
          this.selectedChannels.push(channelCode);
        }
      } else {
        // Al desmarcar un canal, se elimina del arreglo y se desmarca "TODOS"
        this.selectedChannels = this.selectedChannels.filter(code => code !== channelCode);
        this.selectAllChannels = false;
      }
      this.getRoutes(this.selectedChannelIds[0].toString());
    }
  
  //Gets the list of organizations
  getOrg() {
    this.loading = true;
    this.orgServ.getActiveOrgs().subscribe(data => {
      this.org = data;
      this.orgId = this.userLogin.OrgId
    });
  }

  /**
   * Changes data grid filtering the data by the received argument and validates if the country is selected to apply extra filter
   *
   * @param {*} event - Filter received from DOM
   * @memberof RegionListComponent
   */
  changeFilterOrg(event: any): void {
    this.orgId = event;
  }

  // Evento cuando se limpia el combo de centro de ventas
  setOutputNode(event: any){
    this.ceveNode = event;
    this.getChannels();
  }

  // Evento cuando se limpia el combo de centro de ventas
  clearOutputNode() {
    this.ceveNode = this.initialNode;
  }

  getPaybillListExpiredList() {

    if( this.selectedChannels.length> 0){
      this.selectedChannelId =  this.channelList.find(x => x.ChannelCode == this.selectedChannels[0]).UnitId;
    } else {
      this.selectedChannelId = 0;
    }

    if(this.selectedRoutes.length > 0){
      this.selectedRoutelId= this.routes.find(x => x.RouteId == this.selectedRoutes[0]).RouteId
    } else {
      this.selectedRoutelId = 0;
    }
    if(this.selectAll==true){
      this.selectedRoutes = [0];
    }

     this.paybillService.getPaybillListMultichannel (this.userLogin.Org, this.ceveNode.UnitOrgId, this.ceveNode.UnitId,this.selectedChannelIds,this.selectedRoutes,this.selectedDate,this.selectedDateFinal
     ).subscribe(result => {

    if( result.length > 0){
      this.ceqListGrid = result;
      this.baseLoadData = result;
      this.loadData = this.baseLoadData;    
      this.cols = Object.keys(result[0]);
    }else{
    this.loadData = [];
    this.baseLoadData = [];
    }
    this.loading = false;
  });
}

  /**
   * Obtiene los canales de venta asignados al centro de venta
   */
  getChannels() {
    this.channelList = [];
    this.ceveService.getChannelsbyCeve(this.ceveNode.UnitId).subscribe(data => {
      this.channelList = data;
      if(data.length > 0){
        this.selectedChannelId = 0;
        this.selectedChannel = '0';
        this.getRoutes( this.selectedChannel[0]);
      this.getPaybillListExpiredList();
      }else{
        this.globalService.messageToast('No se encontraron canales asignados al centro de venta.', 'warning');
        console.log('No se encontraron canales');
      }
    });
  }


  filterRoutes() {

    this.getPaybillListExpiredList();
    if(this.filtered == false){  
        this.loadData = this.baseLoadData;       
    }
    this.filtered = false;
  }

  cmbRouteChange() {
    this.filterRoutes();
  }

  /**

   * @param channelid 
   */
  changeChannel(){
   
    this.getRoutes(this.selectedChannel);
    this.getPaybillListExpiredList();
    this.getLoadData();

  }

  // Obtiene los datos de vales
  async getLoadData() {
    if(this.selectAll==true){
      this.selectedRoutes = [0];
    }
    this.paybillService.getPaybillListMultichannel (this.userLogin.Org, this.ceveNode.UnitOrgId, this.ceveNode.UnitId,this.selectedChannelId[0],this.selectedRoute[0], this.selectedDate ,this.selectedDateFinal
    ).subscribe(result => {
      this.loadData = [];
      this.baseLoadData = [];
   if( result.length > 0){
     this.baseLoadData = result;
     this.cols = Object.keys(result[0]);
     this.filterChannel();
   }
   this.loading = false;
 });
    
  }


   // Obtiene las rutas del canal seleccionado
  
   getRoutes(channelCode: string) {
    // Si la primera opción no es 'TODOS' (valor '0')
    if (this.selectedChannels.length > 0 && this.selectedChannels[0] !== '0') {
      // Se mapea cada código seleccionado a su correspondiente ChannelId
      const selectedChannelIds = this.selectedChannels
        .map(chCode => {
          const channelObj = this.channelList.find(x => x.ChannelCode === chCode);
          return channelObj ? channelObj.UnitId : null;
        })
        .filter(selectedChannelId => selectedChannelId !== null) as number[]; // Filtramos posibles null y forzamos el tipo a number[]
  
      // Guardamos el arreglo de IDs en una variable (asegúrate de declararla en tu componente)
      this.selectedChannelIds = selectedChannelIds;
  
      // Si necesitas hacer alguna comparación con channelCode, deberás adaptarlo,
      // ya que channelCode es un string y selectedChannelIds es un arreglo de números.
      // Por ejemplo, podrías verificar si alguno de los IDs coincide con el ID asociado al channelCode:
      const channelObj = this.channelList.find(x => x.ChannelCode === channelCode);
      if (channelObj) {
   //     this.selectedChannel = selectedChannelIds.includes(channelObj.ChannelId);
      }
    } else {
      // Si se seleccionó "TODOS", asignamos el valor 0
      this.selectedChannelIds=[0];
      this.selectedRoutes=[0];
      //       this.selectedChannel = false;
    }
  
    // Llamada a la API.
    // Si la API espera un solo ID, podrías enviar el primero del arreglo:
    const channelIdToSend = this.selectedChannelIds;
  

    // Creamos un arreglo de observables para cada canal seleccionado
  const observables = channelIdToSend.map(channelId => 
    this.ceveService.getCeveRoutes(this.ceveNode.UnitId, channelId)
  );

  // Usamos forkJoin para esperar a que todas las peticiones se completen
  forkJoin(observables).subscribe(
    results => {
      // results es un arreglo donde cada posición corresponde al resultado de cada llamada a la API.
      // Si cada resultado es un arreglo de rutas, los combinamos en uno solo:
      this.routes = results.reduce((acc, curr) => acc.concat(curr), []);
   

      if (this.routes != null) {
        this.selectedRoute = 0;
        if (this.baseLoadData.length > 0) {
          this.filterChannel();
        } else {
          this.getLoadData();
        }
      } else {
        this.selectedRoute = null;
      }
    },
    error => {
      // Manejo de error
      console.error('Error al obtener rutas para los canales seleccionados', error);
    },
    () => {
      // Se ejecuta al completar todas las peticiones
      this.cmbRouteChange();
    }
  );


    // this.ceveService.getCeveRoutes(this.ceveNode.UnitId, this.selectedChannelIds[0]).subscribe(data => {
    //          this.routes = data;
    //     if (data != null) {
    //       this.selectedRoute = 0;
    //       if (this.baseLoadData.length > 0) {
    //         this.filterChannel();
    //       } else {
    //         this.getLoadData();
    //       }
    //     } else {
    //       this.selectedRoute = null;
    //     }
    //   },
    //   error => { },
    //   () => { this.cmbRouteChange(); }

    // );
   }
  
  // Método que filtrar la tabla de rutas con el canal seleccionado
  filterChannel() {
    this.filtered = true;
      this.loadData = this.baseLoadData; 
  }
  
  async onDateSelected(date: string) {

    if((this.selectedDate) > (this.selectedDateFinal))
    {
      if (date == 'start') {
      this.globalService.messageToast('La fecha inicial no puede ser mayor a la fecha final.', 'error');
      this.selectedDate = this.globalService.getStringDate(this.currentDate, false, 0);
      return;
        
    }
    else{
      this.globalService.messageToast('La fecha final no puede ser menor a la fecha inicial.', 'error');
      this.selectedDateFinal = this.globalService.getStringDate(this.currentDate, false, 0);
      return;
    }
  }

    this.getPaybillListExpiredList();
    this.getLoadData();
  }

  filterdate(){

    this.getLoadData();
  }


}